import { useNavigate } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";

import { ClientCard } from "@components/Cards";

import { routes } from "@pages/routes";

export const Client = () => {
  const { clientId } = useTypedParams(routes.portal.clients.client);
  const navigate = useNavigate();

  const handleDeleteSuccess = () => {
    navigate(routes.portal.clients.$path(), {
      viewTransition: true,
      replace: true,
    });
  };

  const handleUpdateClientSuccess = () => {
    navigate(routes.portal.clients.$path(), {
      viewTransition: true,
    });
  };

  return (
    <ClientCard
      clientId={clientId}
      onDeleteSuccess={handleDeleteSuccess}
      onUpdateClientSuccess={handleUpdateClientSuccess}
    />
  );
};
